export enum DocumentType {
    ElectronicCV = 0,
    PMBPacket = 1,
    MedicalPractitionerRegistration = 2,
    MedicalIndemnity = 3,
    Training = 4,
    SitePiApproval = 5,
}